import { useMemo } from 'react';
import { Select } from 'antd';
import { useLanguage } from '../contexts/I18nContext';
import { type LanguageCode } from '../i18n/languages';
import { getLanguageOptions } from '../i18n/displayNames';
import { KEEPER_IGNORE_CLASS } from '../utils/passwordManagers';

interface LanguageSwitcherProps {
  // Passthrough so the switcher can match the density of its surrounding toolbar.
  size?: 'small' | 'middle' | 'large';
}

const LanguageSwitcher = ({ size }: LanguageSwitcherProps) => {
  const { language, setLanguage, availableLanguages } = useLanguage();
  // Endonym options for only the languages this app ships (shared with the profile
  // dropdown). Recomputed if the available set changes.
  const options = useMemo(() => getLanguageOptions(availableLanguages), [availableLanguages]);

  return (
    <Select<LanguageCode>
      value={language}
      onChange={(value) => setLanguage(value)}
      options={options}
      size={size}
      // Let the dropdown panel size to its content (full language name) instead of being
      // clamped to the trigger's width, which can be narrow in a compact toolbar.
      popupMatchSelectWidth={false}
      // Give the collapsed trigger a sensible floor so the selected language name isn't
      // cramped before the dropdown is opened; it can still grow to fill its container.
      style={{ minWidth: 140 }}
      classNames={{input: KEEPER_IGNORE_CLASS}}
    />
  );
};

export default LanguageSwitcher;
